import { Alert, AlertTitle, Box, SxProps, Theme, Typography } from "@mui/material";
import { HazardReviewReason } from "generated-graphql/graphql";

const HAZARD_REVIEW_REASON_LABELS: Record<HazardReviewReason, string> = {
  [HazardReviewReason.DropsLegacyHazard]:
    "The hazard categories leave out a legacy hazard this chemical had.",
  [HazardReviewReason.NoHazardClassification]:
    "The SDS gives no hazard classification and does not say the product is not classified.",
  [HazardReviewReason.UnresolvedHazardClass]:
    "The SDS names a hazard class without a category, so it was not added.",
  [HazardReviewReason.UnresolvedInhalationRoute]:
    "The state portal does not say which acute toxicity inhalation category applies.",
  [HazardReviewReason.VerifiedChemicalChanged]:
    "An SDS extraction changed this chemical after it was verified.",
};

/** Why automation flagged this chemical's hazards; verifying clears it. */
export function HazardReviewAlert({
  reasons,
  sx,
}: {
  reasons: readonly HazardReviewReason[];
  sx?: SxProps<Theme>;
}) {
  if (reasons.length === 0) {
    return null;
  }
  return (
    <Alert severity="warning" role="status" sx={sx}>
      <AlertTitle>Check the hazards against the SDS, then verify the chemical</AlertTitle>
      <Box component="ul" sx={{ my: 0, pl: 2.5 }}>
        {reasons.map((reason) => (
          <li key={reason}>
            <Typography variant="body2">{HAZARD_REVIEW_REASON_LABELS[reason]}</Typography>
          </li>
        ))}
      </Box>
    </Alert>
  );
}
